import axios from 'axios';
import api from './api';

export default {
    list(payload) {
        return axios.post('/color/list/', payload);
    },
    searchByRalNrAndType(ralnr, raltype) {
        const payload = {
            ralnr: ralnr && ralnr.length >= 2 ? ralnr : undefined,
            raltype: raltype && raltype.length >= 1 ? raltype : undefined,
        };
        return axios.post('/color/list/', payload);
    },
    export() {
        return api.createGetUrl('/color/export/');
    },
    updateSort(colorId, sort) {
        return axios.post('/color/updateColorSort/', {
            colorId,
            sort,
        });
    },
    update(payload) {
        return axios.post('/color/update/', payload);
    },
    fetch(colorId) {
        return axios.post('/color/fetch/', { colorId });
    },
    remove(colorId) {
        return axios.post('/color/remove/', { colorId });
    },
    fetchPaintlist(colorId) {
        return axios.post('/color/fetchPaintlist', { colorId });
    },
    reset() {
        return axios.post('/color/reset/');
    },
    import(colors) {
        return axios.post('/color/import/', {
            resultArray: JSON.stringify(colors),
        });
    },
    fetchAttachedSuppliers(colorId) {
        return axios.get(`[API]/colors/${colorId}/suppliers`);
    },
    updateOrAttachSuppliers(colorId, suppliers) {
        return axios.post(`[API]/colors/${colorId}/suppliers`, {
            suppliers,
        });
    },
};
